import { Component, OnInit, Output, Input, EventEmitter } from '@angular/core';
import { StorageS3HttpMethodsService } from '../storage-s3-http-methods.service';
import { StorageHsbshareHttpMethodsService } from '../storage-hsbshare-http-methods.service';
import { MatAutocompleteSelectedEvent } from '@angular/material';
import { Observable } from 'rxjs/Observable';
import { startWith } from 'rxjs/operators/startWith';
import { map } from 'rxjs/operators/map';
import { FormControl } from '@angular/forms';

@Component({
  selector: 'app-list-root-containers',
  templateUrl: './list-root-containers.component.html',
  styleUrls: ['./list-root-containers.component.css']
})
export class ListRootContainersComponent implements OnInit {

  myControl: FormControl = new FormControl();

  selectedIndex;

  _rootContainerLabel;
  @Input('rootContainerLabel')
  set rootContainerLabel(value:string) {
    this._rootContainerLabel = value;
  }
  get rootContainerLabel(){
    return this._rootContainerLabel;
  } 

  accessKeyId;
  secretAccessKey;

  rootContainers = [];
  rootContainerObjects = [];
  rootContainerObjectsFiltered = [];
  filteredRootContainers: Observable<string[]>;
  
  inputText;
    
  storageProvider;//supported: s3,hsbShare

  @Output() rootContainerChanged: EventEmitter<string> = new EventEmitter<string>();




  constructor(private storageS3HttpMethodsService: StorageS3HttpMethodsService,
              private storageHsbshareHttpMethodsService: StorageHsbshareHttpMethodsService) {

  }

  ngOnInit() {
    // this.filteredRootContainers = this.myControl.valueChanges
    //   .pipe(
    //     startWith(''),
    //     map(val => this.filter(val))
    //   );

  }
  filter(rootContainerValue: string): string[] {
    this.rootContainerObjectsFiltered = this.rootContainerObjects.filter(rootContainer =>
      rootContainer.Name.toLowerCase().indexOf(rootContainerValue.toLowerCase()) === 0);

    return this.rootContainers.filter(rootContainer =>
      rootContainer.toLowerCase().indexOf(rootContainerValue.toLowerCase()) === 0);
  }
  getPlaceHolder(){
    return this.rootContainerLabel;
  }
  setFilterContainers(){
    this.filteredRootContainers = this.myControl.valueChanges
    .pipe(
      startWith(''),
      map(val => this.filter(val))
    );
  }
  resetFilterContainers(){
    this.filteredRootContainers = null;
  }
  listRootContainerHsbShare(){
    return new Promise((resolve, reject) => {
      this.storageProvider = 'hsbShare';
      this.storageHsbshareHttpMethodsService.getProjects()
      .then(data => {
        if(!data || !data.projects){
          return reject('null data');
        }
        this.rootContainers = data.projects.map(project => project.name);
        this.rootContainerObjects = data.projects.map(project => {return {Name: project.name, projectId: project.projectID};});
        this.rootContainerObjectsFiltered = data.projects.map(project => {return {Name: project.name, projectId: project.projectID};});
        this.setFilterContainers();
        resolve(this.rootContainers);
      }).catch(error => {
        this.rootContainers = [];
        this.rootContainerObjects = [];
        this.rootContainerObjectsFiltered = [];
        this.resetFilterContainers();
        reject(error);
      });
    });
  }

  listRootContainersS3(accessKeyId, secretAccessKey) {
    return new Promise((resolve, reject) => {
      this.storageProvider = 's3';
      this.accessKeyId = accessKeyId;
      this.secretAccessKey = secretAccessKey;
  
      this.storageS3HttpMethodsService.listBuckets(accessKeyId, secretAccessKey)
        .then(data => {
          if(!data || !data.Buckets){
            return reject('null data');
          }
          this.rootContainers = data.Buckets.map(bucket => bucket.Name);
          this.rootContainerObjects = data.Buckets.map(bucket => { return {Name: bucket.Name, Id: bucket.Name}; });
          this.rootContainerObjectsFiltered = data.Buckets.map(bucket => { return {Name: bucket.Name, Id: bucket.Name}; });
          this.setFilterContainers();
          
          resolve(this.rootContainers);
        }).catch(error => {
          this.rootContainers = [];
          this.rootContainerObjects = [];
          this.rootContainerObjectsFiltered = [];
          this.resetFilterContainers();
          reject(error);
        });
    });
  }
  // onRootContainerChanged(event: MatAutocompleteSelectedEvent)
  // {
  //   this.inputText = event.option.value;
  //   this.rootContainerChanged.emit(event.option.value);
  // }
  onRootContainerChanged(e, rootContainer, index)
  {
    if(e.source.selected){
        this.selectedIndex = index;
        this.inputText = rootContainer;
        this.rootContainerChanged.emit(this.rootContainerObjectsFiltered[index]);
        this._resetContainers();
    }
  }

  clearText(){
    this.inputText = '';
  }
  private _resetContainers(){
    if(this.storageProvider === 's3'){
        this.listRootContainersS3(this.accessKeyId, this.secretAccessKey);
    }else if(this.storageProvider == 'hsbShare') {
        this.listRootContainerHsbShare();
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/list-root-containers/list-root-containers.component.ts